import { makeAutoObservable } from "mobx";
import {
    deleteICDCodeService,
    getAllICDCodeServices,
    getICDCodeServiceById,
    getListByIcdCode,
    pagingICDCodeService,
    saveICDCodeListConcept,
    saveOrUpdate,
    getListMediReqFormByICD
} from 'app/services/ICDCodeServiceService';

import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { ICDCodeService } from "app/common/Model/ICDCodeService";
import { checkSearchObject } from "app/common/LocalFunction";

export default class ICDCodeServiceStore {
    listAllICDCodeService = [];
    searchICDCodeService = new SearchObject();
    pageICDCodeService = null;
    selectedICDCodeService = null;
    openFormCreateOrEdit = false;
    openConfirmDelete = false;
    recentlyUpdated = false;
    isViewListByIcd = false;
    listServiceByIcd = []

    constructor() {
        makeAutoObservable(this);
    }

    getListServiceByIcd = async (obj) => {
        const res = await getListMediReqFormByICD(obj)
        //console.log(res.data);
    }

    getAllICDCodeServices = async () => {
        return await getAllICDCodeServices()
            .then(({ data }) => {
                this.listAllICDCodeService = data || [];
            })
            .catch(error => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi", "Thông báo");
            })
    }
    pagingICDCodeService = async () => {
        return await pagingICDCodeService(this.searchICDCodeService)
            .then(({ data }) => {
                this.pageICDCodeService = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi", "Thông báo")
            })
    }

    handleChangeFormSearch = (searchICDCodeService) => {
        this.searchICDCodeService = checkSearchObject(this.searchICDCodeService, searchICDCodeService);
        this.pagingICDCodeService();
    }

    handleOpenFormCreateOrEdit = (iCDCodeServiceId) => {
        if (Boolean(iCDCodeServiceId)) {
            getICDCodeServiceById(iCDCodeServiceId).then(({ data }) => {
                this.selectedICDCodeService = data;
                this.openFormCreateOrEdit = true;
                this.isViewListByIcd = false;
            })
        } else {
            this.selectedICDCodeService = new ICDCodeService();
            this.openFormCreateOrEdit = true;
            this.isViewListByIcd = false;
        }
    }

    handleOpenFormCreateOrEditList = (iCDCodeServiceId) => {
        if (Boolean(iCDCodeServiceId)) {
            getListByIcdCode(iCDCodeServiceId?.concept?.id).then(({ data }) => {
                this.selectedICDCodeService = data;
                this.openFormCreateOrEdit = true;
                this.isViewListByIcd = true;
            })
        } else {
            this.selectedICDCodeService = new ICDCodeService();
            this.openFormCreateOrEdit = true;
            this.isViewListByIcd = true;
        }
    }

    saveOrUpdateICDCodeService = (iCDCodeService, { setSubmitting }) => {
        saveOrUpdate(iCDCodeService)
            .then(() => {
                this.selectedICDCodeService = null;
                toast.success("Lưu dữ liệu thành công!");
                this.handleClosePopup();
                this.pagingICDCodeService();
                this.recentlyUpdated = true;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lưu dữ liệu có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    saveOrUpdateListICDCodeService = (iCDCodeService, { setSubmitting }) => {
        saveICDCodeListConcept(iCDCodeService)
            .then(() => {
                this.selectedICDCodeService = null;
                toast.success("Lưu dữ liệu thành công!");
                this.handleClosePopup();
                this.pagingICDCodeService();
                this.recentlyUpdated = true;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lưu dữ liệu có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    handleDelete = (iCDCodeService) => {
        this.selectedICDCodeService = { id: iCDCodeService?.id };
        this.openConfirmDelete = true;
    }

    handleConfirmDelete = async () => {
        return await deleteICDCodeService(this.selectedICDCodeService?.id)
            .then(() => {
                if (this.searchICDCodeService?.pageIndex > 1 && this.pageICDCodeService?.content?.length === 1) {
                    this.searchICDCodeService.pageIndex -= 1;
                }
                toast.success("Xóa bản ghi thành công!");
                this.handleClosePopup();
                this.pagingICDCodeService();
                this.recentlyUpdated = true;
            })
            .catch(err => {
                console.error(err);
                toast.error("Xóa bản ghi có lỗi", "Thông báo");
            })
    }

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

    resetStore = () => {
        this.searchICDCodeService = new SearchObject();
        this.pageICDCodeService = null;
        this.selectedICDCodeService = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
        this.listServiceByIcd = []
    }

    //for choosing iCDCodeService in ChooseICDCodeServicePopup.jsx 
    listICDCodeService = [];
    iCDCodeServiceIdSet = null;

    isValidICDCodeService = iCDCodeService => {
        if (iCDCodeService && iCDCodeService?.id) return true;
        console.error("Invalid manipulated element");
        return false;
    }

    addICDCodeService = iCDCodeService => {
        if (!this.isValidICDCodeService(iCDCodeService)) return;
        this.listICDCodeService.push(iCDCodeService);
        this.iCDCodeServiceIdSet.add(iCDCodeService?.id);
    }

    initializelistICDCodeService = iCDCodeServices => {
        this.iCDCodeServiceIdSet = new Set();
        this.listICDCodeService = [];
        if (iCDCodeServices && iCDCodeServices?.length > 0) {
            for (let i = 0; i < iCDCodeServices.length; i++) {
                this.addICDCodeService(iCDCodeServices[i]);
            }
        }
    }

    removeICDCodeService = iCDCodeService => {
        if (!this.isValidICDCodeService(iCDCodeService)) return;
        if (this.iCDCodeServiceIdSet.has(iCDCodeService?.id)) {
            this.iCDCodeServiceIdSet.delete(iCDCodeService?.id);
        } else {
            console.error("Element is not exist");
        }
    }

    isExist = iCDCodeService => {
        if (!this.isValidICDCodeService(iCDCodeService)) return;
        return this.iCDCodeServiceIdSet.has(iCDCodeService?.id);
    }

    getICDCodeServiceIdSet = () => {
        return this.iCDCodeServiceIdSet;
    }

    getListICDCodeService = () => {
        const bufferIdSet = new Set();
        const data = [];
        if (this.listICDCodeService && this.listICDCodeService?.length > 0) {
            for (let i = 0; i < this.listICDCodeService.length; i++) {
                const iCDCodeService = this.listICDCodeService[i];
                if (this.isExist(iCDCodeService) && !bufferIdSet.has(iCDCodeService?.id)) {
                    data.push(iCDCodeService);
                    bufferIdSet.add(iCDCodeService?.id);
                }
            }
        }
        this.listICDCodeService = data;
        return data;
    }

}
